exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".weui-dialog__bd {\n  height: 100%;\n  max-height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/components/ModalTagSelector.less
// module id = 1352
// module chunks = 0